import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateTimeDisplay from './DateTimeDisplay';

export default class DateTimeIntervalDisplay extends Component {
  static propTypes = {
    useTimezone: PropTypes.string,
    start_date: PropTypes.string.isRequired,
    end_date: PropTypes.string.isRequired,
    inline: PropTypes.bool,
    show_date: PropTypes.bool,
    full_day_name: PropTypes.bool,
    show_timezone: PropTypes.bool,
  }

  static defaultProps = {
    show_date: true,
    show_timezone: true,
    inline: false,
    useTimezone: moment.tz.guess(),
    full_day_name: false,
  }

  render() {
    let startDate;
    let endDate;
    let startDateTimeSeparator;
    let endDateTimeSeparator;
    let startEndSeparator;

    const sameDay = moment(this.props.start_date)
      .tz(this.props.useTimezone)
      .isSame(this.props.end_date, 'day');

    if (this.props.inline) {
      startEndSeparator = <span>&nbsp;</span>;
    } else {
      startEndSeparator = <br />;
    }

    if (this.props.show_date) {
      startDate = (
        <DateTimeDisplay
          timestamp={this.props.start_date}
          useTimezone={this.props.useTimezone}
          date_only
          full_day_name={this.props.full_day_name}
        />
      );
      if (sameDay) {
        if (!this.props.inline) {
          startDateTimeSeparator = <br />;
        } else {
          startDateTimeSeparator = <span>,&nbsp;</span>;
        }
        startEndSeparator = <span>&nbsp;&mdash;&nbsp;</span>;
      } else {
        startDateTimeSeparator = <span>&nbsp;</span>;
        endDateTimeSeparator = <span>&nbsp;</span>;
        endDate = (
          <DateTimeDisplay
            timestamp={this.props.end_date}
            useTimezone={this.props.useTimezone}
            date_only
          />
        );
      }
    } else {
      startEndSeparator = <span>&nbsp;&mdash;&nbsp;</span>;
    }

    return (
      <span>
        {startDate}
        {startDateTimeSeparator}
        <DateTimeDisplay
          timestamp={this.props.start_date}
          useTimezone={this.props.useTimezone}
          format={'h:mm A'}
        />
        {startEndSeparator}
        {endDate}
        {endDateTimeSeparator}
        <DateTimeDisplay
          timestamp={this.props.end_date}
          useTimezone={this.props.useTimezone}
          time_only
          show_timezone={this.props.show_timezone}
        />
      </span>
    );
  }
}
